{
  "me": "(я)",
  "meta": {
    "title": "Тайтл",
    "description": "Описание",
    "home": "Главная",
    "auth": "Авторизация",
    "register": "Регистрация",
    "surferRegister": "Регистрация серфера",
    "recoverPassword": "Восстановление пароля",
    "resetPassword": "Сброс пароля",
    "verifyEmail": "Подтверждение email",
    "userList": "Список пользователей",
    "userProfile": "Профиль пользователя",
    "userEdit": "Редактирование пользователя",
    "companyProfile": "Профиль компании",
    "companyEdit": "Редактирование компании",
    "reviews": "Отзывы"
  },
  "photo": "Фото пользователя",
  "name": "Имя",
  "managerUpperCase": "Менеджер",
  "recruiterUpperCase": "Рекрутер",
  "connectionError": "Ошибка соединения",
  "networkError": "Потеряно соединение с интернетом. Проверьте подключение и попробуйте снова.",
  "error": "Ошибка",
  "apply": "Применить",
  "reset": "Сбросить",
  "in": "в",
  "address": "Адрес",
  "creationDate": "Дата создания",
  "region": "Регион",
  "city": "Город",
  "all": "Все",
  "cabinet": "Личный кабинет",
  "employeeRefresh": {
    "error": "Ошибка при обновлении ответственного сотрудника"
  },
  "uploadFile": {
    "error": "Ошибка при загрузке файла"
  },
  "updateData": {
    "error": "Ошибка при обновлении данных"
  },
  "request": {
    "error": "Ошибка при отправке запроса"
  },
  "navigation": {
    "main": "Основная навигация",
    "vacancies": "Вакансии",
    "employees": "Сотрудники",
    "sintiaDialog": "Диалог с Синтией",
    "sintiaDialogButton": "Поговорим",
    "faq": "FAQ",
    "reviews": "Отзывы",
    "openMenu": "Открыть меню",
    "closeMenu": "Закрыть меню"
  },
  "sintiaDialog": {
    "chat": {
      "aiName": "Синтия",
      "you": "Вы",
      "messageLabel": "Сообщение Синтии",
      "placeholder": "Введите сообщение",
      "send": "Отправить",
      "listen": "Прослушать",
      "recommendedCandidatesDrawerTitle": "Рекомендованные кандидаты",
      "candidateDetails": "Подробнее",
      "candidateAge": "Возраст: {{age}}",
      "candidatePhone": "Номер телефона",
      "candidateLoading": "Загружаем кандидата",
      "candidateUnavailable": "Не удалось загрузить кандидата. Возможно, он больше недоступен.",
      "vacancyUnavailable": "Не удалось загрузить вакансию. Возможно, она больше недоступна.",
      "loadError": "Не удалось загрузить сообщения",
      "retry": "Повторить",
      "messageFailed": "Сообщение не доставлено",
      "waitingForReply": "Ожидаем ответ Синтии…",
      "audioFormatHint": "Формат аудиофайла: OGG Кодировка OPUS *",
      "unsupportedAudioFile": "Можно отправить только аудиофайл OGG или WebM с кодеком Opus",
      "attachFile": "Прикрепить файл",
      "voiceMessage": "Голосовое сообщение",
      "openActionsMenu": "Открыть меню действий",
      "sendMessage": "Отправить сообщение",
      "actionsMenu": {
        "showOpenVacancies": "Показать открытые вакансии",
        "startCandidateSelection": "Начать подбор кандидатов",
        "createVacancy": "Создать вакансию"
      },
      "surferUnknownCandidateChoice": {
        "text": "Для выбора кандидата нажмите кнопку «Посмотреть» и выберите понравившегося кандидата.",
        "view": "Посмотреть"
      },
      "surferStopOrResumeSearch": {
        "text": "К сожалению, в этой облегченной версии я могу создавать только одно предложение о работе в месяц. Чтобы остановить или возобновить поиск, войдите в систему, используя свой адрес электронной почты и пароль, на   https://client.cynthia.africa/ .",
        "view": "Посмотреть"
      },
      "recordVoiceTitle": "Записать голосовое сообщение",
      "uploadAudioTitle": "Отправить аудиофайл",
      "listenAudioTitle": "Прослушать аудиофайл",
      "cancel": "Отмена",
      "finishRecordingToSend": "Закончите запись, чтобы отправить сообщение",
      "inlineVoice": {
        "leaveSending": "Сообщение уже отправляется. Уход из диалога не отменяет отправку.",
        "leaveTitle": "Уйти из диалога?",
        "leaveDraft": "Голосовое сообщение не отправлено. Если уйти, запись будет удалена.",
        "stay": "Остаться",
        "leave": "Уйти",
        "previewFailed": "Не удалось прослушать запись. Можно отправить её или записать сообщение заново.",
        "emptyRecording": "Запись пуста. Удалите её и запишите сообщение ещё раз.",
        "requesting": "Разрешите доступ к микрофону в браузере",
        "finishing": "Завершаем запись…",
        "recording": "Идёт запись · нажмите стоп, чтобы прослушать",
        "review": "Можно прослушать и отправить",
        "textSaved": "Набранный текст сохранён",
        "progress": "Позиция прослушивания"
      },
      "voiceRecorder": {
        "startHint": "Начните запись",
        "startRecording": "Начать запись",
        "stopRecording": "Остановить запись",
        "play": "Воспроизвести",
        "pause": "Пауза",
        "unmute": "Включить звук",
        "mute": "Выключить звук",
        "loadingDuration": "Определяется длительность записи",
        "delete": "Удалить",
        "browserUnsupported": "Ваш браузер не поддерживает запись голоса.",
        "errors": {
          "unknownMime": "Не удалось определить тип записи",
          "microphoneAccess": "Не удалось получить доступ к микрофону",
          "microphoneDenied": "Нет доступа к микрофону. Разрешите его в настройках браузера",
          "microphoneNotFound": "Микрофон не найден",
          "microphoneBusy": "Микрофон занят другим приложением",
          "recordingFailed": "Запись прервалась. Попробуйте ещё раз",
          "audioLoadFailed": "Файл обрабатывается. Попробуйте прослушать его позже.",
          "audioNetworkFailed": "Не удалось загрузить файл. Проверьте подключение к интернету.",
          "audioDecodeFailed": "Не удалось воспроизвести файл."
        }
      }
    },
    "guide": {
      "openGuide": "Открыть руководство"
    }
  },
  "sintiaDialogGuide": {
    "title": "Руководство",
    "howToDialog": {
      "title": "Как вести диалог?",
      "description": "Формулируйте вопросы своими словами. Специальных форматов или шаблонов не требуется. Синтия постарается развернуто ответить на ваш вопрос и помочь с возникшей проблемой"
    },
    "vacancyCreation": {
      "title": "Создание вакансии",
      "description": "В процессе диалога Синтия может создать подходящую вакансию на основе информации, полученной от вас. Созданная вакансия будет доступна в разделе \"Вакансии\""
    }
  },
  "forms": {
    "registerPersonal": {
      "name": {
        "title": "Имя",
        "placeholder": "Введите ваше имя"
      },
      "surname": {
        "title": "Фамилия",
        "placeholder": "Введите вашу фамилию"
      },
      "company": {
        "title": "Название компании",
        "placeholder": "Введите название компании",
        "withoutName": "Нет названия компании",
        "delete": "Удалить компанию"
      }
    },
    "register": {
      "formOrg": {
        "title": "Форма организации",
        "placeholder": "Выберите организационно-правовую форму"
      }
    },
    "surferRegister": {
      "email": {
        "title": "Email",
        "description": "Данный электронный адрес будет использоваться в качестве логина при последующих подключениях",
        "hintControlLabel": "Информация об адресе электронной почты",
        "placeholder": "yoremail@mars.com"
      },
      "phone": {
        "title": "Номер WhatsApp",
        "description": "На данный WhatsApp-номер будут приходить оповещения, как только будут найдены новые кандидаты, удовлетворяющие вашим критериям",
        "hintControlLabel": "Информация о номере WhatsApp",
        "placeholder": "+"
      },
      "company": {
        "title": "Название компании",
        "placeholder": "Введите название компании"
      },
      "ncc": {
        "title": "NCC",
        "placeholder": "Введите NCC"
      },
      "firstName": {
        "title": "Имя",
        "placeholder": "Введите Ваше имя"
      },
      "lastName": {
        "title": "Фамилия",
        "placeholder": "Введите Вашу фамилию"
      },
      "password": {
        "title": "Пароль",
        "confirmation": "Подтвердите пароль",
        "placeholder": "Введите пароль"
      }
    },
    "activitySphere": {
      "title": "Сфера деятельности",
      "description": "Выберите все сферы деятельности компании",
      "placeholder": "Выберите",
      "nothingFound": "Ничего не найдено"
    },
    "economicActivity": {
      "title": "Сфера экономической деятельности",
      "description": "Выберите все сферы экономической деятельности компании",
      "placeholder": "Выберите"
    },
    "employmentType": {
      "title": "Тип занятости",
      "description": "На постоянную занятость или разовая работа по найму",
      "placeholder": "Выберите"
    },
    "region": {
      "title": "Регион",
      "description": "Адрес, где будет работать сотрудник",
      "placeholder": "Выберите",
      "errorMessage": "Нельзя выбрать несколько регионов"
    },
    "city": {
      "title": "Город",
      "description": "В каком городе предстоит работать",
      "placeholder": "Выберите",
      "errorMessage": "Укажите город"
    },
    "filters": {
      "from": "От",
      "to": "До",
      "currency": "Валюта",
      "period": "Период",
      "surnameName": "Фамилия Имя",
      "phone": "Телефон",
      "status": "Статус",
      "role": "Роль",
      "searchFail": "К сожалению, совпадений не найдено",
      "subDesc": "Попробуйте изменить параметры фильтров. Чтобы вернуться ко всему списку, сбросьте фильтр.",
      "vacancy": {
        "searchFail": "К сожалению, совпадений не найдено",
        "filteredSubDesc": "Попробуйте изменить параметры фильтров. Чтобы вернуться ко всему списку, сбросьте фильтр.",
        "empty": "Список вакансий пуст",
        "subDesc": "Чтобы создать вакансию в компании, нажмите кнопку «Создать вакансию»"
      }
    },
    "fileUpload": {
      "fileFormat": "Файл в формате png, jpg, jpeg, webp.",
      "maxSize": "Максимальный размер: 254kb",
      "allowedFormats": "Допустимые форматы: PNG, JPG, JPEG, WEBP",
      "maxSizeError": "Максимальный размер файла: 254 КБ",
      "uploadError": "Ошибка при загрузке файла"
    },
    "company": {
      "title": "Компания",
      "name": "Введите название компании",
      "form": {
        "title": "Форма организации",
        "description": "Выберите организационно-правовую форму компании"
      },
      "nif": {
        "title": "NIF",
        "description": "Введите Número de Identificação Fiscal"
      },
      "ncc": {
        "title": "NCC",
        "description": "Введите регистрационный номер компании",
        "placeholder": "0000000Р",
        "status": {
          "verified": "Подтвержден",
          "rejected": "Не подтвержден",
          "pending": "Не проверено"
        }
      },
      "manager": {
        "title": "Менеджер компании",
        "description": "Контактное лицо компании, администрирует компанию"
      },
      "description": {
        "title": "Описание компании",
        "description": "Кратко опишите компанию для кандидатов"
      }
    },
    "vacancy": {
      "title": "Вакансия",
      "vacancyPlace": "Кол-во вакантных мест",
      "setupNumberEmployee": "Установите число кандидатов, предлагаемых на вакансию",
      "name": {
        "title": "Название вакансии",
        "description": "Введите название должности, на которую Синтия будет искать лучшего кандидата"
      },
      "company": {
        "title": "Компания",
        "description": "Выберите компанию-нанимателя"
      },
      "description": {
        "title": "Описание вакансии",
        "description": "Кратко опишите компанию для кандидатов"
      }
    },
    "dateRange": {
      "from": "с",
      "to": "до"
    },
    "scheduleWork": {
      "title": "График работы",
      "description": "Укажите график работы",
      "placeholder": "Выберите"
    },
    "skill": {
      "title": "Ключевые навыки",
      "description": "Выберите все необходимые ключевые навыки сотрудника",
      "placeholder": "Выберите"
    },
    "placeholders": {
      "enterName": "Введите название",
      "enterDescription": "Введите описание"
    }
  },
  "loginForm": {
    "title": "Войти в личный кабинет работодателя",
    "description": "Введите Email и пароль для входа в личный кабинет"
  },
  "auth": {
    "verifyEmailSuccess": "Email успешно подтвержден",
    "verifyEmailError": "Ошибка при отправке запроса",
    "resetPasswordSuccess": "Пароль успешно изменен",
    "recoverPasswordInfo": "Проверьте вашу почту. На указанный Email отправлена ссылка для восстановления пароля",
    "enterPass": "Введите пароль",
    "next": "Далее",
    "confirmRegister": "Нажимая кнопку «Зарегистрироваться», я соглашаюсь с пользовательским соглашением и с политикой использования персональных данных",
    "userAgreement": "Пользовательское соглашение",
    "privacyPolicy": "Политика конфиденциальности",
    "confirmPass": "Подтверждение пароля",
    "password": "Пароль",
    "forgotPass": "Забыли пароль?",
    "login": "Войти",
    "logOut": "Выйти",
    "noAcc": "Нет аккаунта?",
    "hasAccount": "Есть аккаунт?",
    "recoverPass": "Восстановить",
    "remindPass": "Вспомнили пароль?",
    "resetPassword": {
      "title": "Восстановление пароля",
      "description": "Пожалуйста, задайте новый надёжный пароль для входа в личный кабинет"
    },
    "register": {
      "title": "Зарегистрироваться",
      "description": "Чтобы начать подбор персонала с Синтией, создайте аккаунт",
      "error": "Ошибка при регистрации"
    },
    "surferWelcome": {
      "title": "Добро пожаловать в клуб!",
      "startDialog": "Начать диалог"
    },
    "recoverPassword": {
      "message": "Проверьте вашу почту. На указанный Email отправлена ссылка для восстановления пароля",
      "forgotPass": "Забыли пароль?",
      "description": "На указанный в форме email мы отправим ссылку для восстановления пароля",
      "title": "Войти",
      "back": "Вернуться назад"
    }
  },
  "company": {
    "employees": {
      "title": "Сотрудники компании",
      "management": "Управление сотрудниками компании осуществляется в разделе",
      "users": "пользователи"
    },
    "reviews": {
      "title": "Отзывы",
      "empty": "Нет ни одного отзыва",
      "ratingOfFive": "{{value}} из 5",
      "hired": "Был нанят",
      "notHired": "Не был нанят",
      "interviewDone": "Собеседование состоялось",
      "interviewNotDone": "Собеседование не состоялось",
      "pageTitle": "Отзывы",
      "companyRatingSummary": "Рейтинг компании {{value}} {{unit}}",
      "ratingLabel": "Оценка: {{value}}",
      "detailTitle": "Отзыв кандидата от {{date}}",
      "comment": "Комментарий",
      "interviewCancellationReason": "Причина несостоявшегося собеседования",
      "columns": {
        "reviewAt": "Дата и время отзыва",
        "ratingTotal": "Оценка",
        "vacancy": "Вакансия",
        "isHired": "Нанят",
        "interviewDone": "Собеседование"
      },
      "filters": {
        "createdAtFrom": "Дата создания, От",
        "createdAtTo": "Дата создания, До",
        "dateRangeError": "Дата «До» не может быть раньше даты «От»"
      },
      "answersLegend": {
        "yes": "Да",
        "no": "Нет"
      }
    },
    "rating": {
      "title": "Рейтинг компании",
      "score": "{{value}} {{unit}}",
      "scoreUnits": {
        "one": "балл",
        "few": "балла",
        "many": "баллов"
      },
      "howToImprove": "Как повысить уровень",
      "hint": "Рейтинг рассчитывается на основе качества наполненности вакансии и оценок кандидатов",
      "levels": {
        "none": "Нет уровня",
        "iron": "Железный уровень",
        "bronze": "Бронзовый уровень",
        "silver": "Серебряный уровень",
        "gold": "Золотой уровень",
        "platinum": "Платиновый уровень"
      },
      "levelsShort": {
        "none": "Нет уровня",
        "iron": "Железный",
        "bronze": "Бронзовый",
        "silver": "Серебряный",
        "gold": "Золотой",
        "platinum": "Платиновый"
      },
      "howToImproveModal": {
        "title": "Как повысить уровень",
        "currentLevel": "Ваш текущий уровень:",
        "currentLevelValue": "{{level}} / {{score}}",
        "nextLevelHint": {
          "before": "Чтобы перейти на",
          "after": "уровень повысьте свой балл на:"
        },
        "maxLevelMessage": "Вы достигли максимального уровня! Поддерживайте его для привлечения лучших кандидатов.",
        "improveTitle": "Что нужно сделать для повышения уровня:",
        "maintainTitle": "Что нужно делать для поддержания уровня:",
        "tips": {
          "vacancies": {
            "title": "Улучшайте описание своих вакансий:",
            "body": "заполняйте все поля и предоставляйте подробное описание."
          },
          "company": {
            "title": "Заполняйте все данные о компании:",
            "body": "удостоверьтесь, что все данные о компании заполнены."
          },
          "interaction": {
            "title": "Увеличивайте качество взаимодействия с кандидатами и сотрудниками:",
            "body": "повысьте качество коммуникации, условия труда, уровень гостеприимства, условия оплаты и прочие моменты, позволяющие сформировать положительное впечатление и оставить отзыв."
          }
        }
      }
    },
    "info": {
      "description": "Описание компании",
      "edit": "Редактировать",
      "company": "Компания",
      "region": "Регион",
      "city": "Город",
      "manager": "Менеджер компании",
      "activitySphere": "Сфера деятельности",
      "descriptionTitle": "Описание компании"
    },
    "edit": {
      "personalData": "Личные данные",
      "updateSuccess": "Компания успешно обновлена",
      "updateError": "Произошла ошибка при обновлении компании"
    },
    "nccCandidatePick": {
      "missingMessage": "Чтобы выбрать кандидата, укажите NCC вашей компании. Выбор будет доступен после успешной проверки NCC.",
      "title": "Выбор кандидата",
      "pendingMessage": "Проверка NCC вашей компании выполняется. Дождитесь окончания проверки, чтобы перейти к подбору кандидатов.",
      "failedMessage": "Вы не можете перейти к подбору кандидатов, так как указанный NCC не удалось проверить. Укажите корректный NCC ниже",
      "nccRequired": "Обязательно для заполнения",
      "close": "Закрыть",
      "cancel": "Отмена",
      "save": "Сохранить"
    },
    "delete": {
      "title": "Удалить компанию",
      "description": {
        "first": "Удаление компании приведет к ",
        "second": "удалению вакансий и сотрудников",
        "third": " компании. Хотите удалить все данные компании, безвозвратно?"
      },
      "buttons": {
        "confirm": "Да, удалить",
        "cancel": "Отмена"
      },
      "errorMessage": "Произошла ошибка при удалении компании"
    }
  },
  "user": {
    "title": "Пользователи",
    "create": {
      "title": "Создать пользователя"
    },
    "edit": {
      "personalData": "Личные данные",
      "updateError": "Ошибка при обновлении данных",
      "updateSuccess": "Пользователь успешно обновлен"
    }
  },
  "vacancy": {
    "error": "Ошибка при создании вакансии",
    "actions": {
      "title": "Действия",
      "copy": "Копировать"
    },
    "mainInfo": {
      "title": "Основная информация"
    },
    "edit": {
      "saveError": "Не удалось сохранить вакансию",
      "workingConditions": {
        "title": "Условия работы",
        "requirements": "Требования",
        "mandatoryRequirements": "Обязательные требования к кандидату",
        "additionalRequirements": "Дополнительные требования к кандидату",
        "additionalRequirementsDesc": "Добавьте специальные требования, важные для Вас, чтобы Синтия смогла уточнить их у кандидата и дать выбрать для Вас лучшего из лучших. Например, кандидат должен знать иностранный язык или иметь опыт работы в необходимой области более 5 лет, подтвержденный рекомендациями",
        "mandatoryRequirementsDesc": "Укажите здесь только самые важные требования к кандидату, на которые Синтия должна ориентироваться в выборе. Кандидаты не соответствующие этим требованиям она не будет рассматривать. Например, для водителя обязательно нужны водительские права.",
        "responsibilities": {
          "title": "Обязанности",
          "description": "Опишите, какие задачи должен будет выполнять работник на работе, за что отвечать",
          "subTitle": "Трудовые обязанности"
        },
        "typeEmployment": "Тип занятости",
        "workingHours": "График работы",
        "lvlSalary": "Уровень дохода",
        "suggestLvlSalary": "Важно указать реальный желаемый диапазон, чтобы ваш запрос получил больше откликов.",
        "keySkills": "Ключевые навыки",
        "saveError": "Не удалось сохранить условия работы"
      }
    }
  },
  "employee": {
    "edit": {
      "create": "Создать",
      "save": "Сохранить"
    }
  },
  "buttons": {
    "askDelete": "Хотите удалить все данные вакансии безвозвратно?",
    "confirmDelete": "Да, удалить",
    "deny": "Отмена",
    "back": "Назад",
    "save": "Сохранить",
    "edit": "Редактировать",
    "delete": "Удалить"
  },
  "ui": {
    "selectDate": {
      "placeholder": "Выберите дату"
    },
    "filters": {
      "subDescription": "Попробуйте изменить параметры фильтров. Чтобы вернуться ко всему списку, сбросьте фильтр.",
      "asc": "По возрастанию",
      "desc": "По убыванию",
      "clear": "Очистить",
      "search": "Поиск",
      "vacancy": {
        "id": "ID вакансии"
      },
      "name": {
        "placeholder": "Фильтр по имени"
      },
      "date": {
        "asc": "По возрастанию даты",
        "desc": "По убыванию даты",
        "clear": "Очистить "
      },
      "title": "Фильтры",
      "filtration": "Фильтрация",
      "reset": "Сбросить",
      "apply": "Применить",
      "defaultPlaceHolder": "Выберите значения",
      "all": "Все",
      "status": "Статус"
    },
    "modal": {
      "warning": "Неактивный рекрутер не имеет доступа к управлению вакансиями"
    },
    "dataTable": {
      "empty": {
        "description": "К сожалению, совпадений не найдено"
      }
    }
  },
  "statusBadge": {
    "active": "Активен",
    "inactive": "Неактивен"
  },
  "video": {
    "unmute": "Включить звук",
    "mute": "Выключить звук"
  },
  "recruiter": "Рекрутер",
  "manager": "менеджер",
  "registrationVerification": {
    "continue": "Продолжить",
    "title": "Подтвердите электронную почту",
    "sentTo": "Мы отправили код на",
    "digitLabel": "Цифра кода подтверждения",
    "confirm": "Подтвердить",
    "back": "Изменить данные",
    "errors": {
      "required": "Champ obligatoire",
      "email": "Adresse email invalide",
      "terms": "Veuillez accepter les conditions.",
      "password_mismatch": "Les mots de passe ne correspondent pas",
      "password_length": "Le mot de passe doit contenir entre 8 et 64 caractères.",
      "invalid": "La valeur saisie est invalide.",
      "company_taken": "Une entreprise porte déjà ce nom. Choisissez un autre nom.",
      "validation_failed": "Vérifiez les champs indiqués.",
      "email_taken": "Un compte existe déjà avec cette adresse email. Connectez-vous.",
      "code_invalid": "Ce code est incorrect. Vérifiez les chiffres et réessayez.",
      "code_expired": "Ce code a expiré. Demandez un nouveau code.",
      "attempts_exhausted": "Vous avez atteint cinq tentatives incorrectes. Demandez un nouveau code.",
      "verification_required": "Demandez un nouveau code pour cette adresse email.",
      "verification_replaced": "Ce code a été remplacé. Utilisez le code du dernier email.",
      "verification_consumed": "Cette vérification a déjà été utilisée. Connectez-vous si votre compte existe.",
      "resend_too_soon": "Veuillez patienter avant de demander un nouveau code.",
      "send_limit_exceeded": "La limite d’envoi a été atteinte. Réessayez plus tard.",
      "request_limit_exceeded": "Trop de tentatives. Veuillez patienter avant de réessayer.",
      "mail_unavailable": "Le code n’a pas pu être envoyé. Réessayez dans un instant.",
      "verification_unavailable": "La vérification est indisponible. Réessayez dans un instant.",
      "technical": "Une erreur est survenue. Réessayez. Nous ne pouvons pas confirmer la création du compte.",
      "cooldown": "Un nouveau code pourra être envoyé dans {{seconds}} s."
    },
    "expires": "Код действует ещё {{minutes}} мин {{seconds}} с.",
    "resend": "Отправить код повторно",
    "resendIn": "Отправить повторно через {{seconds}} с",
    "latestCode": "После повторной отправки используйте код только из последнего письма.",
    "automaticHint": "Первый полностью введённый код проверится автоматически."
  }
}
